<template>
    <stat-layout-card>
        <template #title>
            <h2 class="m-0">{{ data.title }}</h2>
        </template>
        <template #content>
            <div v-if="mainSlot" class="data-block-number aright">
                <h3
                    v-for="(slot, mainSlotIndex) in mainSlot.slots"
                    :key="mainSlotIndex"
                    class="data-value aright"
                >
                    {{ slot.type === 'amount' ? $filters.numberFormat(slot.value) : slot.value }}
                    {{ slot.unit ? slot.unit : '' }}
                </h3>
            </div>
            <h4 class="grey ml-2">{{ $l10n.__('Total') }}</h4>
            <div
                v-for="(stat, statIndex) in statsFiltered"
                :key="statIndex"
                class="stats-block stats-inline"
            >
                <a :href="stat.link" target="_blank" class="primary-50-hover cpointer gray-100">
                    <h3 class="stats-title">{{ stat.label }}</h3>
                    <div
                        v-for="(value, valueIndex) in stat.slots"
                        :key="valueIndex"
                        class="data-block-number inline-block"
                    >
                        <h3 class="data-value m-0">
                            {{
                                value.type === 'amount'
                                    ? $filters.numberFormat(value.value)
                                    : value.value
                            }}
                            {{ value.unit ? value.unit : '' }}
                        </h3>
                        <!-- <p class="data-label">{{ value.label }}</p> -->
                    </div>
                </a>
            </div>
        </template>
    </stat-layout-card>
</template>

<script>
import StatLayoutCard from './StatLayoutCard.vue';
export default {
    components: {
        StatLayoutCard,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        mainSlot() {
            const mainSlot = this.data.slots.find((slot) => slot.name === 'total');
            if (mainSlot) {
                return mainSlot;
            }
            return false;
        },
        statsFiltered() {
            return this.data.slots.filter((slot) => slot.name !== 'total');
        },
    },
};
</script>
